var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "25px",
    viewBox: "0 0 41 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA079C8C-879E-44C8-BD0F-BCCF9316BC0C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02198518,0.288889933 C1.04003768,0.288889933 0.0446847553,1.24362283 0.0446847553,2.18869027 L0.0446847553,2.18869027 L40.3514512,3.16597592 C40.3514512,1.23288343 39.3784406,0.288889933 37.3665095,0.288889933 L37.3665095,0.288889933 L2.02198518,0.288889933 Z",
    id: "path-31"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-2:-SecurionPay",
    transform: "translate(-16.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(16.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.363116)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06068231,24.408944 C1.12806665,24.408944 0.189686786,23.5068342 0.189686786,21.6381781 L0.189686786,2.15690164 C0.189686786,1.26553121 1.12806665,0.363421387 2.04410413,0.363421387 L37.356232,0.363421387 C39.2888477,0.363421387 40.2272275,1.26553121 40.2272275,3.13418728 L40.2272275,21.6381781 C40.2272275,23.5068342 39.2888477,24.408944 37.356232,24.408944 L3.06068231,24.408944 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3564554,0.202330347 L2.04432755,0.202330347 C1.03892056,0.202330347 0.0223423776,1.17961599 0.0223423776,2.14616224 L0.0223423776,21.6274387 C0.0223423776,23.5712706 1.02774937,24.5485563 3.04973455,24.5485563 L37.3564554,24.5485563 C39.3784406,24.5485563 40.3838476,23.5712706 40.3838476,21.6274387 L40.3838476,3.13418728 C40.3838476,1.17961599 39.3784406,0.202330347 37.3564554,0.202330347 M37.3564554,0.513773025 C39.1997016,0.513773025 40.0710543,1.34070703 40.0710543,3.13418728 L40.0710543,21.6381781 C40.0710543,23.420919 39.2108728,24.2575184 37.3564554,24.2575184 L3.06090574,24.2575184 C1.21765958,24.2575184 0.346306854,23.4316584 0.346306854,21.6381781 L0.346306854,2.15690164 C0.346306854,1.36218584 1.21765958,0.513773025 2.04432755,0.513773025 L37.3564554,0.513773025",
    id: "Fill-3",
    fill: "#C4C5C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0.000000, 0.363116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-6-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "6.49057242 0.277291378 0.0447964672 5.21741662 0.0447964672 0.277291378"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-9-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "0.0447964672 5.21752401 6.49057242 0.277398772 8.70246781 0.277398772"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#F6F6F5",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "1.51916997 24.484442 0.0445730434 24.484442 0.0445730434 23.9152537"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-15-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "39.7581493 0.277291378 40.3613935 0.277291378 40.3613935 1.52306209"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-18-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "40.3613935 6.62449316 17.0471224 24.4841198 14.8240559 24.4841198"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-21-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#EFEFEF",
    fillRule: "nonzero",
    mask: "url(#mask-12)",
    points: "40.3613935 8.32131879 19.2590178 24.4841198 17.0471224 24.4841198 40.3613935 6.62449316"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-24-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#EEEEEE",
    fillRule: "nonzero",
    mask: "url(#mask-14)",
    points: "40.3613935 10.0287764 21.4820844 24.4840125 19.2590178 24.4840125 40.3613935 8.32121139"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-27-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#EDEDED",
    fillRule: "nonzero",
    mask: "url(#mask-16)",
    points: "40.3613935 11.7257094 23.705151 24.4841198 21.4820844 24.4841198 40.3613935 10.0288838"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-30-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#ECECEC",
    fillRule: "nonzero",
    mask: "url(#mask-18)",
    points: "40.3613935 13.4219981 25.9170464 24.4846568 23.705151 24.4846568 40.3613935 11.7251725"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-33-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#ECEBEB",
    fillRule: "nonzero",
    mask: "url(#mask-20)",
    points: "40.3613935 15.1294557 28.1401129 24.4845494 25.9170464 24.4845494 40.3613935 13.4218907"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-36-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#EBEAEB",
    fillRule: "nonzero",
    mask: "url(#mask-22)",
    points: "40.3613935 16.8263888 30.3520083 24.4846568 28.1401129 24.4846568 40.3613935 15.1295631"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-39-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#EAEAEA",
    fillRule: "nonzero",
    mask: "url(#mask-24)",
    points: "40.3613935 18.5232144 32.5750749 24.4846568 30.3520083 24.4846568 40.3613935 16.8263888"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-42-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#E9E9E9",
    fillRule: "nonzero",
    mask: "url(#mask-26)",
    points: "40.3613935 20.2201474 34.7869703 24.4847642 32.5750749 24.4847642 40.3613935 18.5233218"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-45-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#E8E8E8",
    fillRule: "nonzero",
    mask: "url(#mask-28)",
    points: "40.3613935 21.927605 37.0100369 24.4846568 34.7869703 24.4846568 40.3613935 20.22004"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-48-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#E7E7E7",
    fillRule: "nonzero",
    mask: "url(#mask-30)",
    points: "40.3613935 23.6244307 39.2331034 24.4846568 37.0100369 24.4846568 40.3613935 21.927605"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-51-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    mask: "url(#mask-32)",
    points: "39.2334386 24.484442 40.3617286 23.6242159 40.3617286 24.484442"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0.000111711888,21.9791707 C0.000111711888,23.9240765 1.00551871,24.8895488 3.02750388,24.8895488 L37.3677383,24.8895488 C39.3897235,24.8895488 40.3951305,23.9240765 40.3951305,21.9791707 M40.4063017,3.51921139 C40.4063017,1.57430556 39.4008947,0.608833261 37.3789095,0.608833261 L2.03326808,0.608833261 C1.02786108,0.608833261 0.0112829007,1.57430556 0.0112829007,2.55266515 M37.3677383,0.68293514 C38.3508029,0.68293514 39.0992726,0.920275939 39.5796337,1.39280966 C40.071166,1.86534338 40.3169322,2.57414395 40.3169322,3.51921139 M40.3169322,21.9791707 C40.3169322,22.9253121 40.071166,23.644852 39.5796337,24.1055724 C39.0881014,24.5791801 38.3508029,24.8154469 37.3677383,24.8154469 L3.02750388,24.8154469 C2.04443927,24.8154469 1.29596962,24.5791801 0.815608496,24.1055724 C0.324076188,23.6330387 0.0783100337,22.9253121 0.0783100337,21.9791707 M0.0894812225,2.55266515 C0.0894812225,1.62800258 1.07254584,0.694748483 2.02209689,0.694748483 L37.3677383,0.694748483",
    id: "Fill-55",
    fill: "#CCCCCB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3391628,3.32343208 C40.3391628,1.37960019 39.3337558,0.41305395 37.3117707,0.41305395 L2.02198518,0.41305395 C1.01657818,0.41305395 2.84217094e-13,1.37960019 2.84217094e-13,2.34614644 L2.84217094e-13,5.25652457 L40.3391628,5.25652457",
    id: "Fill-57",
    fill: "#255697",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0447964672,20.0358758 L0.0447964672,21.9797077 C0.0447964672,23.9235395 1.05020346,24.8900858 3.07218864,24.8900858 L37.3565671,24.8900858 C39.3673811,24.8900858 40.3839593,23.9235395 40.3839593,21.9797077 L40.3839593,20.0358758 L0.0447964672,20.0358758 Z",
    id: "Fill-59",
    fill: "#D97C17",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1735148,7.86802512 C27.6037842,7.66397647 26.7212602,7.43844901 25.6153125,7.43844901 C22.800173,7.43844901 20.8117014,8.83457136 20.789359,10.8321003 C20.7781878,12.3141378 22.2081,13.1303324 23.2917053,13.624345 C24.397653,14.1290969 24.7774734,14.451279 24.7663022,14.9023339 C24.755131,15.5896557 23.8837783,15.9010983 23.0571103,15.9010983 C21.917649,15.9010983 21.3144049,15.7507467 20.376025,15.3641282 L20.0073758,15.2030372 L19.605213,17.5012693 C20.2754843,17.7912332 21.5043151,18.0382395 22.7890018,18.0489789 C25.7940516,18.0489789 27.7378384,16.6743353 27.7601808,14.5371942 C27.771352,13.3665993 27.0117112,12.4752289 25.3695464,11.7449495 C24.3753106,11.2724158 23.7608952,10.9502337 23.7720664,10.4669606 C23.7720664,10.0373845 24.2859411,9.58632955 25.40306,9.58632955 C26.3414398,9.57559015 27.0117112,9.7688994 27.536757,9.98368745 L27.7936944,10.1018209 L28.1735148,7.86802512",
    id: "Fill-61",
    fill: "#255697",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9721658,14.2581845 C32.2067608,13.6675174 33.1116271,11.3800246 33.1116271,11.3800246 C33.1004559,11.4122428 33.3462221,10.7893574 33.4914475,10.4027389 L33.6813577,11.2941094 C33.6813577,11.2941094 34.228746,13.7534326 34.3404579,14.2581845 L31.9721658,14.2581845 Z M35.4910903,7.62123365 L33.2903661,7.62123365 C32.6089236,7.62123365 32.0950489,7.80380349 31.7934268,8.46964646 L27.5595463,17.8881026 L30.5534249,17.8881026 C30.5534249,17.8881026 31.0449572,16.6208531 31.1566691,16.3405547 L34.8096478,16.3405547 C34.8990173,16.7067683 35.1559547,17.8773632 35.1559547,17.8773632 L37.8035264,17.8773632 L35.4910903,7.62123365 Z",
    id: "Fill-63",
    fill: "#255697",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#255697",
    fillRule: "nonzero",
    points: "14.9807876 17.8984125 16.7681778 7.62080407 19.616831 7.62080407 17.8294408 17.8984125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5785352,7.62101886 L9.78573799,14.6338488 L9.48411589,13.2055083 C8.95907001,11.5623796 7.33924763,9.7796388 5.52951504,8.88826838 L8.08771728,17.8771484 L11.1039383,17.8771484 L15.5947562,7.61027946 L12.5785352,7.61027946",
    id: "Fill-67",
    fill: "#255697",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1942456,7.62101886 L2.59171581,7.62101886 L2.55820224,7.83580691 C6.13298266,8.68421973 8.50127469,10.746185 9.4955105,13.2162477 L8.49010351,8.49091048 C8.32253567,7.83580691 7.81983218,7.64249766 7.1942456,7.62101886",
    id: "Fill-69",
    fill: "#D97C17",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7ec0d9c95c4c636c40b295472ac58790.svg";
export { ForwardRef as ReactComponent };